module.exports = __webpack_public_path__ + "static/img/game-logo-lgd.be20128.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-lgd.png
// module id = vFsc
// module chunks = 0 1 2 3 4 5 6